import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  width: 215px;
  height: 41px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid #8c8c8c;
  border-radius: 2px;
  background: #fff;
  cursor: pointer;
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #5e5e5e;

  &:hover {
    background: #f7f8f8;
  }
`;

type Props = {
  onClick: () => void;
};

// Official Google "G" mark.
const GoogleLogo: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <title>Google</title>
    <path
      fill="#4285F4"
      d="M17.64 9.2045c0-.6382-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2582h2.9086c1.7018-1.5668 2.6836-3.874 2.6836-6.6151z"
    />
    <path
      fill="#34A853"
      d="M9 18c2.43 0 4.4673-.806 5.9564-2.1818l-2.9086-2.2582c-.8059.54-1.8368.859-3.0478.859-2.344 0-4.3282-1.5827-5.036-3.7104H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z"
    />
    <path
      fill="#FBBC05"
      d="M3.964 10.71c-.18-.54-.2823-1.1168-.2823-1.71s.1023-1.17.2823-1.71V4.9582H.9573C.3477 6.1732 0 7.5477 0 9s.3477 2.8268.9573 4.0418L3.964 10.71z"
    />
    <path
      fill="#EA4335"
      d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1623 6.656 3.5795 9 3.5795z"
    />
  </svg>
);

export const GoogleLoginButton: React.FC<Props> = ({ onClick }) => {
  return (
    <StyledButton type="button" onClick={onClick} aria-label="Sign in with Google">
      <GoogleLogo />
      Sign in with Google
    </StyledButton>
  );
};
